import { debugId, toDebugString } from "../debug";
import { evaluateCondition } from "./evaluateCondition";
export const evaluateConditions = function () {
  let conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let options = arguments.length > 1 ? arguments[1] : undefined;
  const conditionsReferenceRecord = {};
  for (const condition of conditions) {
    const {
      result,
      toAssign
    } = evaluateCondition(condition, {
      ...options,
      referenceRecord: {
        ...options.referenceRecord,
        ...conditionsReferenceRecord
      }
    });
    if (!result) {
      return {
        result
      };
    }
    if (toAssign) {
      var _options$logger, _options$logger$debug, _options$logger2;
      conditionsReferenceRecord[toAssign.name] = toAssign.value;
      (_options$logger = options.logger) === null || _options$logger === void 0 || (_options$logger$debug = (_options$logger2 = _options$logger).debug) === null || _options$logger$debug === void 0 || _options$logger$debug.call(_options$logger2, debugId, "assign: ".concat(toAssign.name, " := ").concat(toDebugString(toAssign.value)));
    }
  }
  return {
    result: true,
    referenceRecord: conditionsReferenceRecord
  };
};